"use client"

import { useEffect, useState } from "react"
import { unreadStore } from "@/utils/realtime/unreadStore"

export function useConversationUnreadStatuses(userId?: string | null) {
  const [unreadByRoom, setUnreadByRoom] = useState<Record<string, boolean>>({})

  useEffect(() => {
    if (!userId) return

    unreadStore.start(userId)
    const unsub = unreadStore.subscribe(setUnreadByRoom)
    return () => { unsub() }
  }, [userId])

  // Realtime handled by unreadStore/manager; no per-hook subscription here.

  return unreadByRoom
}
